import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {SliderResponseModel} from '@shared/components/slider/model/slider-response.model';
import {MatSliderChange} from '@angular/material/slider';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnChanges {
    @Input() tabindex: number;
    @Input() displayValue: string;
    @Input() disableTabFocus: boolean;
    @Input() disabled: boolean;
    @Input() itemId: string;
    @Input() values: string[];
    @Input() selected: string;
    @Input() showLabel: boolean;
    @Input() testing: any;
    @Input() durationSlider?: boolean;
    @Input() defaultValue: string;
    @Input() ariaLabel: string;
    @Input() cssClasses: string;
    @Output() sliderChangedEvent: EventEmitter<SliderResponseModel> = new EventEmitter();
    position: number;
    response: SliderResponseModel;

    slided(event: MatSliderChange): void {
        this.position = event.value;
        this.selected = this.values[this.position - 1];
        this.response = {
            id: this.itemId,
            selected: this.selected
        };
        this.sliderChangedEvent.emit(this.response);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selected && this.selected) {
            this.position = this.values.indexOf(this.selected) + 1;
        }
    }
}
